import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import WorkPage from './WorkPage';
import ContactPage from './ContactPage';
import { AnimatePresence } from 'framer-motion';

const Pages = () => {
  const location = useLocation();
  const name = "Mahmoud N.";
  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage icon="😎" title={name} />} />
        <Route path="/about" element={<AboutPage icon="💁" title={"About | " + name} />} />
        <Route path="/work" element={<WorkPage icon="💼" title={"Work | " + name} />} />
        <Route path="/contact" element={<ContactPage icon="📞" title={"Contact | " + name} />} />
      </Routes>
    </AnimatePresence>
  )
}

export default Pages;